import { render } from "./Exercise.vue?vue&type=template&id=a802148c&ts=true"
import script from "./Exercise.vue?vue&type=script&lang=ts"
export * from "./Exercise.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__